<template>
  <div ref="searchMarker" style="display: flex;align-items: center;flex-direction: column;">
    <div style="position: relative">
      <img style="width: 56px;height: 56px" src="../../../../assets/SatelliteActivityBuyJpg/marker.png"/>
      <div @click="removeMarker" class="iconfontFamily close-icon">×</div>
    </div>
    <div class="alibabaPuHuiTiFontFamily" style="font-size: 14px;color: white">{{ markerInfo['name'] }}</div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: 'SearchMarker',
  props: {
    map: {
      type: Object,
      required: true
    },
    markerInfo: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      marker: null,
    }
  },
  watch: {
    // 监听 markerInfo 的变化
    markerInfo: {
      handler(newVal, oldVal) {
        console.log('markerInfo 更新:', newVal, oldVal);
        this.updateMarker();
      },
      deep: true, // 深度监听，确保对象内部的属性变化也能触发
    },
  },
  methods: {
    addToMap() {
      // 先移除旧的 marker
      if (this.marker) {
        this.marker.remove();
      }
      this.marker = new mapboxgl.Marker(this.$refs.searchMarker)
          .setLngLat([this.markerInfo.lng, this.markerInfo.lat])
          .addTo(this.map);
    },

    updateMarker() {
      if (this.marker && this.markerInfo) {
        // 如果已经有 marker，更新位置
        this.marker.setLngLat([this.markerInfo.lng, this.markerInfo.lat]);
      } else {
        // 否则创建新的 marker
        this.addToMap();
      }
    },

    // 移除 marker
    removeMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
    },
  },
  mounted() {
    this.addToMap();
  },

  beforeDestroy() {
    // 组件销毁时清理资源
    this.removeMarker();
  },
}
</script>

<style scoped>
.close-icon {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: 4px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
</style>